import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  containerStyle: {
    paddingBottom: 200,
  },
  separatorContainer: { width: '100%', paddingHorizontal: 16 },
  separatorContent: theme => ({
    width: '100%',
    height: 1,
    backgroundColor: theme.colors.borderColorThree,
  }),
  sectionContainer: (theme, active) => ({
    marginHorizontal: 16,
    paddingVertical: 12,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottomWidth: active ? 1 : 0,
    borderBottomColor: theme.colors.borderColorThree,
  }),
  sectionItemTitle: {
    flex: 1,
    marginHorizontal: 16,
    marginTop: 4,
    fontSize: 18,
  },
  deviceImageContainer: {
    width: '100%',
    height: 340,
    justifyContent: 'center',
    alignItems: 'center',
  },
  moreInfoTitle: {
    ...Fonts.type.bold,
    fontSize: 16.6,
    marginLeft: 16,
    marginTop: 36,
    marginRight: 4,
    marginBottom: 8,
    paddingBottom: 10,
  },
  nextStepBtn: {
    width: '100%',
    paddingHorizontal: 16,
    marginTop: 32,
  },
  chevronIcon: theme => ({
    tintColor: theme.colors.hyperlinkFive,
  }),
  listIcon: theme => ({
    tintColor: theme.colors.headerColor,
  }),
  deviceOverViewBtnContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 16,
    marginTop: 35,
  },
  deviceOverViewTxt: {
    marginTop: 3,
    fontSize: 17,
  },
});
